import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';
import Browser from '@wetransfer/concorde-browser';
import Url from '@module/url';

import Action from '@component/preview/action';
import Icon from '@component/icon';

const openLink = (item) => {
  const link = window.open(item.url, '_blank').focus();
  if (link) {
    link.opener = null;
  }
};

const WebContentWrapper = ({ item }) => {
  const containerClassnames = ['preview__container'];

  return (
    <div className={containerClassnames.join(' ')}>
      <div className="preview__item">
        <a
          href={item.url}
          target="_blank"
          className="preview__link"
          rel="noopener noreferrer"
        >
          <span className="preview__link--type">
            {I18n.t('transfer.preview.link')}
          </span>
          <h3 className="preview__link--title">{item.meta.title}</h3>
          <div className="preview__link--domain">
            <Icon type="Link" /> {Url.extractRootDomain(item.url)}
            {Browser.isMobile ? null : (
              <Icon type="OpenLink" className="preview__link--open" />
            )}
          </div>
        </a>
      </div>
      <Action
        title={item.meta.title}
        subTitle={item.url}
        action={{
          text: I18n.t('transfer.preview.visit_website'),
          callback: () => openLink(item),
        }}
      />
    </div>
  );
};

WebContentWrapper.propTypes = {
  item: PropTypes.object,
};

export default WebContentWrapper;
